import styled from 'styled-components';
import breakpoints from '@rsc/ui-components/breakpoints';
import styles from '@utils/styles';

const HorizontalDivider = styled.hr`
  display: block;
  border: none;
  color: ${styles.colors.gray[500]};
  height: 2px;
  background: none;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(25, 25, 25, 0) 5%,
    ${styles.colors.gray[500]} 50%,
    rgba(0, 0, 0, 0) 95%,
    rgba(25, 25, 25, 0) 100%
  );
  margin: 2rem 0;
  @media screen and (min-width: ${breakpoints.md}) {
    margin: 3rem 0;
  }
`;

export default HorizontalDivider;
